import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CatalogSelectionState {
  selectedIds: string[];
}

const initialState: CatalogSelectionState = {
  selectedIds: [],
};

const catalogSelectionSlice = createSlice({
  name: "catalogSelection",
  initialState,
  reducers: {
    toggleSelection: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      const index = state.selectedIds.indexOf(id);
      if (index === -1) {
        state.selectedIds.push(id);
      } else {
        state.selectedIds.splice(index, 1);
      }
    },
    clearSelection: (state) => {
      state.selectedIds = [];
    },
  },
});

export const { toggleSelection, clearSelection } =
  catalogSelectionSlice.actions;
export default catalogSelectionSlice.reducer;
